class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {
    // These toggle submenu panel - level 1 items
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // These toggle submenu panel - level 2 items  
    this.secondLevelItemsWithChildren = this.el.querySelectorAll('.drawer-submenu__item__input');
    this.secondLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // These handle going back from third level to second level
    this.thirdLevelBackButtons = this.el.querySelectorAll('[data-drawer-subsubmenu-close]');
    this.thirdLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });

    // Watch for drawer opening to show all groups if opened via burger menu
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class' && this.el.classList.contains('is-open')) {
          this.handleDrawerOpen();
        }
      });
    });
    observer.observe(this.el, { attributes: true, attributeFilter: ['class'] });
  }

  handleDrawerOpen() {
    // Check if any level group is visible - if not, show first level (burger menu was used)
    const levelGroups = this.el.querySelectorAll('.drawer-menu__level-group');
    const hasVisibleGroup = Array.from(levelGroups).some(group => group.style.display !== 'none');
    
    const firstLevel = this.el.querySelector('.drawer-menu__first-level');
    const drawerTitle = this.el.querySelector('[data-drawer-title]');
    
    if (!hasVisibleGroup) {
      // Opened via burger menu - show 1st level and hide 2nd level groups
      if (firstLevel) firstLevel.style.display = 'block';
      levelGroups.forEach((group) => {
        group.style.display = 'none';
      });
      // Set title to "Menu"
      if (drawerTitle) {
        drawerTitle.textContent = 'Menu';
        drawerTitle.style.display = 'block';
      }
    } else {
      // Opened via specific menu - hide 1st level
      if (firstLevel) firstLevel.style.display = 'none';
    }
  }

  closeAllItems(event, skipEl) {
    // If skipEl is provided, also collect all parent accordion inputs to preserve the hierarchy
    const elementsToSkip = [];
    if (skipEl) {
      elementsToSkip.push(skipEl);
      // Find all parent accordions and their inputs
      let currentElement = skipEl.closest('[data-accordion-item]');
      while (currentElement) {
        currentElement = currentElement.parentElement.closest('[data-accordion-item]');
        if (currentElement) {
          const parentInput = currentElement.querySelector(':scope > input[type="checkbox"]');
          if (parentInput) {
            elementsToSkip.push(parentInput);
          }
        }
      }
    }

    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (elementsToSkip.includes(checkbox)) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
      // Reset to first level when closing
      const firstLevel = this.el.querySelector('.drawer-menu__first-level');
      if (firstLevel) firstLevel.style.display = 'block';
      const levelGroups = this.el.querySelectorAll('.drawer-menu__level-group');
      levelGroups.forEach((group) => {
        group.style.display = 'none';
      });
      // Close all collapsible details
      const collapsibles = this.el.querySelectorAll('details[data-collapsible-item]');
      collapsibles.forEach((details) => {
        details.open = false;
      });
      // Hide the drawer title
      const drawerTitle = this.el.querySelector('[data-drawer-title]');
      if (drawerTitle) {
        drawerTitle.style.display = 'none';
        drawerTitle.textContent = '';
      }
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }

    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');
    const menuTitle = button.textContent.trim();

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    // Set the drawer title (1st level menu name)
    const drawerTitle = this.el.querySelector('[data-drawer-title]');
    if (drawerTitle) {
      drawerTitle.textContent = menuTitle;
      drawerTitle.style.display = 'block';
    }

    // Hide first level and show only the 2nd level group matching this parent URL
    const firstLevel = this.el.querySelector('.drawer-menu__first-level');
    if (firstLevel) firstLevel.style.display = 'none';
    
    const levelGroups = this.el.querySelectorAll('.drawer-menu__level-group');
    let activeGroup = null;
    levelGroups.forEach((group) => {
      if (group.getAttribute('data-parent-url') === url) {
        group.style.display = 'block';
        activeGroup = group;
      } else {
        group.style.display = 'none';
      }
    });

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);

      // Check if this level-group has banners
      if (activeGroup) {
        const hasBanners = activeGroup.classList.contains('--has-banners');
        if (hasBanners) {
          // Auto-open the banner panel by triggering its checkbox
          setTimeout(() => {
            const bannerInput = activeGroup.querySelector('.drawer-menu__item__input.--banner-input');
            if (bannerInput) {
              bannerInput.checked = true;
              const changeEvt = new Event('change');
              bannerInput.dispatchEvent(changeEvt);
            }
          }, 50);
        } else {
          // No banners, auto-open first item with children as before
          setTimeout(() => {
            const firstItemWithChildren = activeGroup.querySelector('.drawer-menu__item__input');
            if (firstItemWithChildren && firstItemWithChildren.closest('[data-accordion-item]')) {
              firstItemWithChildren.checked = true;
              const changeEvt = new Event('change');
              firstItemWithChildren.dispatchEvent(changeEvt);
            }
          }, 50);
        }
      }
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    // Close only this specific panel by unchecking its input
    const accordion = input.closest('[data-accordion-item]');
    if (accordion) {
      accordion.classList.remove('is-open');
      input.checked = false;
    }

    // Check if there are still any open submenus
    const stillHasOpenItems = this.el.querySelector('[data-accordion-item].is-open');
    if (!stillHasOpenItems) {
      this.mainLevel.classList.remove('has-open-submenu');
    }

    // Restore the title when going back (only if going back to first level)
    const drawerTitle = this.el.querySelector('[data-drawer-title]');
    const firstLevel = this.el.querySelector('.drawer-menu__first-level');
    
    // If first level is visible, it's burger menu - show "Menu" title
    if (firstLevel && firstLevel.style.display !== 'none') {
      if (drawerTitle) {
        drawerTitle.textContent = 'Menu';
        drawerTitle.style.display = 'block';
      }
    }
  }

  toggleSubSubPanel(event) {
    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-subsubmenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    // Close only this specific 3rd level panel
    const accordion = input.closest('[data-accordion-item]');
    if (accordion) {
      accordion.classList.remove('is-open');
      input.checked = false;
    }
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}

// Reset drawer menu item inputs
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.drawer-menu__item__input').forEach((cb) => {
    if (cb) cb.checked = cb.defaultChecked;
  });
})